document.addEventListener(
  "DOMContentLoaded",
  initializeBestSellerFunctionality
);

function initializeBestSellerFunctionality() {
  handleBsSideShieldToggleImage();
  handleBsHoverImage();
  handleAddToCart();
}

/**
 * Handle side shield toggle image functionality
 */
function handleBsSideShieldToggleImage() {
  const toggleSwitches = document.querySelectorAll(
    "[data-side-shield-toggler]"
  );
  const isCollectionPage = window.location.pathname.includes("collections");

  if (!isCollectionPage && toggleSwitches.length === 0) return;

  toggleSwitches.forEach((toggleSwitch) => {
    toggleSwitch.addEventListener("change", handleToggleChange);
  });
}

/**
 * Handle toggle change event
 * @param {Event} event - The change event
 */
function handleToggleChange(event) {
  const isChecked = event.target.checked;
  const parent = event.target.closest(".ombraz__product-grid-item");
  const elements = getProductElements(parent);

  if (!elements.allElementsExist()) return;

  updateProductImages(isChecked, elements);
  updateProductPrice(isChecked, elements.price);
}

/**
 * Get product elements
 * @param {HTMLElement} parent - The parent element
 * @returns {Object} Object containing product elements
 */
function getProductElements(parent) {
  return {
    firstImage: parent.querySelector("[data-first-image]"),
    firstHoverImage: parent.querySelector("[data-hover-image]"),
    secondImage: parent.querySelector("[data-first-shield-image]"),
    secondHoverImage: parent.querySelector("[data-second-shield-image]"),
    price: parent.querySelector(".ombraz-bs-price p"),
    allElementsExist: function () {
      return (
        this.firstImage &&
        this.firstHoverImage &&
        this.secondImage &&
        this.secondHoverImage &&
        this.price
      );
    },
  };
}

/**
 * Update product images based on toggle state
 * @param {boolean} isChecked - Whether the toggle is checked
 * @param {Object} elements - Object containing product elements
 */
function updateProductImages(isChecked, elements) {
  const { firstImage, firstHoverImage, secondImage, secondHoverImage } =
    elements;

  if (!firstImage.dataset.originalSrc) {
    saveOriginalImageData(firstImage, firstHoverImage);
  }

  if (isChecked) {
    setImageSources(firstImage, secondImage);
    setImageSources(firstHoverImage, secondHoverImage);
  } else {
    restoreOriginalImageData(firstImage, firstHoverImage);
  }
}

/**
 * Save original image data
 * @param {HTMLImageElement} firstImage - The first image element
 * @param {HTMLImageElement} firstHoverImage - The first hover image element
 */
function saveOriginalImageData(firstImage, firstHoverImage) {
  firstImage.dataset.originalSrc = firstImage.src;
  firstImage.dataset.originalSrcset = firstImage.srcset;
  firstHoverImage.dataset.originalSrc = firstHoverImage.src;
  firstHoverImage.dataset.originalSrcset = firstHoverImage.srcset;
}

/**
 * Set image sources
 * @param {HTMLImageElement} targetImage - The target image element
 * @param {HTMLImageElement} sourceImage - The source image element
 */
function setImageSources(targetImage, sourceImage) {
  targetImage.src = sourceImage.src;
  targetImage.srcset = sourceImage.srcset;
}

/**
 * Restore original image data
 * @param {HTMLImageElement} firstImage - The first image element
 * @param {HTMLImageElement} firstHoverImage - The first hover image element
 */
function restoreOriginalImageData(firstImage, firstHoverImage) {
  firstImage.src = firstImage.dataset.originalSrc;
  firstImage.srcset = firstImage.dataset.originalSrcset;
  firstHoverImage.src = firstHoverImage.dataset.originalSrc;
  firstHoverImage.srcset = firstHoverImage.dataset.originalSrcset;
}

/**
 * Update product price based on toggle state
 * @param {boolean} isChecked - Whether the toggle is checked
 * @param {HTMLElement} priceElement - The price element
 */
function updateProductPrice(isChecked, priceElement) {
  const sideShieldPrice = 65;
  const currentPrice = Number(priceElement.innerHTML.replace("$", ""));
  const newPrice = isChecked
    ? currentPrice + sideShieldPrice
    : currentPrice - sideShieldPrice;

  const USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  priceElement.innerHTML = USDollar.format(newPrice);
}

/**
 * Handle hover image functionality
 */
function handleBsHoverImage() {
  const cards = document.querySelectorAll(".ombraz__product-grid-item");

  if (cards.length === 0) return;

  cards.forEach((card) => {
    const elements = getCardElements(card);

    if (!elements.allElementsExist()) return;

    if (window.innerWidth >= 799) {
      card.addEventListener("mouseover", () => handleCardHover(elements));
      card.addEventListener("mouseleave", () => handleCardLeave(elements));
    }
  });
}

/**
 * Get card elements
 * @param {HTMLElement} card - The card element
 * @returns {Object} Object containing card elements
 */
function getCardElements(card) {
  return {
    firstImage: card.querySelector("[data-first-image]"),
    firstHoverImage: card.querySelector("[data-hover-image]"),
    secondImage: card.querySelector("[data-first-shield-image]"),
    secondHoverImage: card.querySelector("[data-second-shield-image]"),
    toggle: card.querySelector("[data-side-shield-toggler]"),
    addToCartBtn: card.querySelector("[data-variant-addtocart-btn]"),
    mainProductId: card.querySelector(".parentProductId")?.value || null,
    sideShieldProductId:
      card.querySelector("[data-side-shield-toggler]")?.value || null,
    allElementsExist: function () {
      return (
        this.firstImage &&
        this.firstHoverImage &&
        this.toggle &&
        this.addToCartBtn &&
        this.mainProductId
      );
    },
  };
}

/**
 * Handle card hover
 * @param {Object} elements - Object containing card elements
 */
function handleCardHover(elements) {
  const { firstImage, firstHoverImage, secondImage, secondHoverImage, toggle } =
    elements;
  const hasTwoImages =
    firstImage && firstHoverImage && !secondImage && !secondHoverImage;

  if (hasTwoImages) {
    toggleImageVisibility(firstImage, firstHoverImage, true);
  } else if (toggle.checked && secondImage && secondHoverImage) {
    toggleImageVisibility(firstImage, firstHoverImage, true);
    hideImages(secondImage, secondHoverImage);
  } else {
    toggleImageVisibility(firstImage, firstHoverImage, true);
    hideImages(secondImage, secondHoverImage);
  }
}

/**
 * Handle card leave
 * @param {Object} elements - Object containing card elements
 */
function handleCardLeave(elements) {
  const { firstImage, firstHoverImage, secondImage, secondHoverImage, toggle } =
    elements;
  const hasTwoImages =
    firstImage && firstHoverImage && !secondImage && !secondHoverImage;

  if (hasTwoImages) {
    toggleImageVisibility(firstImage, firstHoverImage, false);
  } else if (!toggle.checked && secondImage && secondHoverImage) {
    toggleImageVisibility(firstImage, firstHoverImage, false);
    hideImages(secondImage, secondHoverImage);
  } else {
    if (toggle.checked && hasTwoImages) {
      toggleImageVisibility(firstImage, firstHoverImage, false);
    } else {
      hideImages(firstImage, firstHoverImage);
    }
    if (secondImage) showImage(secondImage);
    if (secondHoverImage) hideImage(secondHoverImage);
  }
}

/**
 * Toggle visibility of two images
 * @param {HTMLElement} image1 - First image element
 * @param {HTMLElement} image2 - Second image element
 * @param {boolean} showSecond - Whether to show the second image
 */
function toggleImageVisibility(image1, image2, showSecond) {
  if (showSecond) {
    hideImage(image1);
    showImage(image2);
  } else {
    showImage(image1);
    hideImage(image2);
  }
}

/**
 * Hide multiple images
 * @param {...HTMLElement} images - Image elements to hide
 */
function hideImages(...images) {
  images.forEach((image) => {
    if (image) hideImage(image);
  });
}

/**
 * Show an image
 * @param {HTMLElement} image - Image element to show
 */
function showImage(image) {
  image.classList.remove("hidden");
}

/**
 * Hide an image
 * @param {HTMLElement} image - Image element to hide
 */
function hideImage(image) {
  image.classList.add("hidden");
}

/**
 * Handle add to cart functionality
 */
function handleAddToCart() {
  const addToCartBtns = document.querySelectorAll(
    "[data-variant-addtocart-btn]"
  );

  if (addToCartBtns.length === 0) return;

  addToCartBtns.forEach((btn) => {
    btn.addEventListener("click", handleAddToCartClick);
  });
}

/**
 * Handle add to cart button click
 * @param {Event} event - The click event
 */
async function handleAddToCartClick(event) {
  event.preventDefault();
  event.stopPropagation();

  const button = event.target;
  const parent = button.closest(".ombraz__product-grid-item");
  const mainProductId = parent.querySelector(".parentProductId")?.value || null;
  const sideShieldProductId =
    parent.querySelector("[data-side-shield-toggler]")?.value || null;

  if (!mainProductId) {
    console.log("No main product id");
    return;
  }

  const toggle = parent.querySelector("[data-side-shield-toggler]");

  try {
    // Change button text to "Adding to cart..."
    const originalText = button.textContent;
    button.textContent = "Adding...";
    button.disabled = true;

    if (toggle && toggle.checked) {
      await OmbrazUtils.addToCart(mainProductId, sideShieldProductId);
    } else {
      await OmbrazUtils.addToCart(mainProductId);
    }

    await OmbrazUtils.addProduct(mainProductId);
    OmbrazUtils.updateSlideCart({ isUpdate: true, isOpen: true });

    // Change button text to "Added!"
    button.textContent = "Added!";

    // Reset button text after 2 seconds
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 2000);
  } catch (error) {
    // console.error("Error adding product to cart:", error);
    button.textContent = "Add to Cart";
    button.disabled = false;

    // Reset button text after 2 seconds
    setTimeout(() => {
      button.textContent = originalText;
    }, 2000);
  }
}

/**
 * Handle toggle change event
 * @param {Event} event - The change event
 */
async function handleToggleChange(event) {
  event.stopPropagation();
  const isChecked = event.target.checked;
  const parent = event.target.closest(".ombraz__product-grid-item");
  const elements = getProductElements(parent);

  if (!elements.allElementsExist()) return;

  updateProductImages(isChecked, elements);
  updateProductPrice(isChecked, elements.price);

  const mainProductId = parent.querySelector(".parentProductId")?.value || null;
  const sideShieldProductId = event.target.value || null;

  if (!mainProductId) return;

  if (!isChecked) {
    try {
      await OmbrazUtils.removeSideShield(sideShieldProductId, mainProductId);
      OmbrazUtils.updateSlideCart({ isUpdate: true });
    } catch (error) {
      console.error("Error removing side shield:", error);
    }
  }
}
